// extracted by mini-css-extract-plugin
export var readonly = "_hd-1";
export var star = "_hd-0";